import { render, staticRenderFns } from "./videoCourseEdit.vue?vue&type=template&id=236a494a&scoped=true"
import script from "./videoCourseEdit.vue?vue&type=script&lang=js"
export * from "./videoCourseEdit.vue?vue&type=script&lang=js"
import style0 from "./videoCourseEdit.vue?vue&type=style&index=0&id=236a494a&prod&lang=less&scoped=true"
import style1 from "./videoCourseEdit.vue?vue&type=style&index=1&id=236a494a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236a494a",
  null
  
)

export default component.exports